module.exports = __webpack_public_path__ + "static/scale-model-of-houston-graffiti-building-in-houston-texas-095f813969d687fd81120845e3b0feba.png";